import { defineStore } from 'pinia';

const useUserInfo = defineStore('user', {
    state: () => {
        return {
            loginInfo: 0,
            codeList: [],
        };
    },
    actions: {
        initLoginInfo(loginUserInfo) {
            this.loginInfo = loginUserInfo;
            this.codeList = loginUserInfo.codeList;
            this.codeList.push('home');
        },
        editLogin() {
            this.loginInfo = {};
        },
    },
    persist: {
        enabled: true,
    },
});

export default useUserInfo;
